export default __webpack_public_path__ + "static/media/beforeafter.e73f6cbc.png";